import type { Category } from '../types';

export const accident: Category = {
  slug: "if-you-have-an-accident",
  half: "work",
  accent: '#D93025',
  icon: "flag",
  label: { en: "If you have an accident", es: "Si tienes un accidente" },
  blurb: {
    en: "People first, 911, insurance steps in order, then tell us. Read it before you need it.",
    es: "Primero las personas, el 911, los pasos del seguro en orden y luego avísanos. Léelo antes de necesitarlo.",
  },
  guides: [
    {
      slug: "incident-checklist",
      related: [
        "insurance-for-delivery/personal-auto-gap",
        "safety-on-deliveries/severe-weather",
        "reporting-a-problem/what-never-counts-against-you",
      ],
      body: {
        en: {
          title: "Incident checklist",
          summary: "Seven steps, in order, for the minutes after an accident — and a short list to keep in your car.",
          sections: [
            {
              heading: "Read this now, not then",
              paragraphs: [
                "In the moment you will not want to think, so do the thinking now. Read the list today and again before your next shift. The order matters.",
              ],
            },
            {
              heading: "The checklist, in order",
              bullets: [
                "1. People first. Check yourself and everyone else for injuries. Call 911 first, always.",
                "2. Get safe. Move out of traffic if you can. Hazards on.",
                "3. Do not admit fault. Do exchange information: names, insurance, plates, and photos of the scene and the damage.",
                "4. Tell Grocery List Plus from the app (Report a problem → Accident) or call support. Grocery List Plus re-routes your remaining stops and tells your customers. An accident never counts against you.",
                "5. Notify your insurer promptly. Remember the delivery endorsement question — say plainly that you were on a delivery.",
                "6. If a customer's groceries are affected, Grocery List Plus handles the customer. You don't.",
                "7. See a doctor if anything hurts later. Next-day soreness still counts.",
              ],
            },
            {
              heading: "Keep in your car",
              bullets: [
                "Insurance card and registration, where you can reach them.",
                "A phone charger or battery pack.",
                "A pen and a small notebook.",
                "A reflective vest or triangle.",
                "A basic first-aid kit.",
              ],
            },
            {
              heading: "After the day is over",
              paragraphs: [
                "Support will check in with you. Your stops are already covered, so take the time you need. For coverage questions, the insurance guide in this Kit walks through the delivery gap.",
              ],
            },
          ],
          actions: [
            "Read the checklist once today and once before your next shift.",
            "Put the keep-in-your-car items in the glove box this week.",
            "Find Report a problem → Accident in the app so you know where it is.",
            "Ask your insurer the delivery endorsement question if you have not yet.",
          ],
        },
        es: {
          title: "Lista de pasos ante un incidente",
          summary: "Siete pasos, en orden, para los minutos después de un accidente — y una lista corta para tener en tu auto.",
          sections: [
            {
              heading: "Léelo ahora, no en ese momento",
              paragraphs: [
                "En el momento no vas a querer pensar, así que piensa ahora. Lee la lista hoy y otra vez antes de tu próximo turno. El orden importa.",
              ],
            },
            {
              heading: "La lista, en orden",
              bullets: [
                "1. Primero las personas. Revisa si tú o alguien más está herido. Llama al 911 primero, siempre.",
                "2. Ponte a salvo. Sal del tráfico si puedes. Enciende las luces de emergencia.",
                "3. No admitas culpa. Sí intercambia información: nombres, seguro, placas y fotos del lugar y de los daños.",
                "4. Avisa a Lista de Compras Plus desde la app (Reportar un problema → Accidente) o llama a soporte. Lista de Compras Plus redirige tus paradas restantes y avisa a tus clientes. Un accidente nunca cuenta en tu contra.",
                "5. Notifica a tu aseguradora pronto. Recuerda la pregunta del endoso de entregas: di con claridad que estabas en una entrega.",
                "6. Si las compras de un cliente se vieron afectadas, Lista de Compras Plus se encarga del cliente. Tú no.",
                "7. Ve al médico si algo te duele después. El dolor del día siguiente también cuenta.",
              ],
            },
            {
              heading: "Ten en tu auto",
              bullets: [
                "Tarjeta del seguro y registro, a la mano.",
                "Un cargador de teléfono o batería portátil.",
                "Un bolígrafo y una libreta pequeña.",
                "Un chaleco reflectante o un triángulo.",
                "Un botiquín básico de primeros auxilios.",
              ],
            },
            {
              heading: "Cuando termine el día",
              paragraphs: [
                "Soporte se pondrá en contacto contigo. Tus paradas ya están cubiertas, así que tómate el tiempo que necesites. Para dudas de cobertura, la guía de seguros de este Kit explica la brecha en entregas.",
              ],
            },
          ],
          actions: [
            "Lee la lista una vez hoy y otra vez antes de tu próximo turno.",
            "Guarda los artículos de la lista en la guantera esta semana.",
            "Ubica Reportar un problema → Accidente en la app para saber dónde está.",
            "Hazle a tu aseguradora la pregunta sobre el endoso de entregas si aún no lo has hecho.",
          ],
        },
      },
    },
  ],
};
